import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { NoResults } from '../containers/NoResults/NoResults';
import { withApplicationContext } from '../utils/ApplicationContext';

const NoResult = ({ appCtx, searchTerm, isImageSearch }) => {
  const labels = appCtx?.siteConfig?.textDictionary ?? {};

  useEffect(() => {
    appCtx.setBusy(false);
    appCtx.attachResizeListener();
  }, [searchTerm]);

  return (
    <NoResults
      appCtx={appCtx}
      title={labels.SEARCH_WITHOUT_RESULT_TITLE}
      description={labels.SEARCH_WITHOUT_RESULT_DESCRIPTION}
      term={searchTerm}
      regionCode={appCtx.regionCode}
      isImageSearch={isImageSearch}
    />
  );
};

NoResult.defaultProps = {
  appCtx: {},
  searchTerm: PropTypes.string,
  isImageSearch: false,
};

NoResult.propTypes = {
  searchTerm: PropTypes.string,
  appCtx: PropTypes.object,
  isImageSearch: PropTypes.bool,
};

NoResult.getInitialProps = async (config, { query }) => {
  const searchTerm = query && query.Ntt ? encodeURIComponent(query.Ntt) : '';
  const isImageSearch = query?.isImageSearch;
  return { searchTerm, isImageSearch };
};

export default withApplicationContext(NoResult);
export { NoResult };
